import { ApiService } from '../../../base/services/data/api.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { SimpleLookupModel } from '../../../base/models/lookups/simple-lookup.model';

@Injectable()
export class DriversLookupService {
    public error: any;
    public hasError: boolean;
    constructor(public apiService: ApiService) {
    }
    public getActiveEmployees(): Observable<SimpleLookupModel[]> {
        return this.apiService.get<SimpleLookupModel[]>(`api/DriversLookup/GetActiveEmployees`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public getSimpleActiveEmployees(): Observable<SimpleLookupModel[]> {
        return this.apiService.get<SimpleLookupModel[]>(`api/DriversLookup/GetSimpleActiveEmployees`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public getSimpleActiveDriversByLHOrState(stateCode : string): Observable<SimpleLookupModel[]> {
        return this.apiService.get<SimpleLookupModel[]>(`api/DriversLookup/GetSimpleActiveDriversByLHOrState?stateCode=${stateCode}`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public getSimpleActiveDriversWithCodeAndPhone(): Observable<SimpleLookupModel[]> {
        return this.apiService.get<SimpleLookupModel[]>(`api/DriversLookup/GetSimpleActiveDriversWithCodeAndPhone`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public getSimpleActiveSubcontractors(): Observable<SimpleLookupModel[]> {
        return this.apiService.get<SimpleLookupModel[]>(`api/DriversLookup/GetSimpleActiveSubcontractors`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    public getSimpleDGDriverStatuses(): Observable<SimpleLookupModel[]> {
        return this.apiService.get<SimpleLookupModel[]>(`api/DriversLookup/GetSimpleDGDriverStatuses`).pipe(
            catchError(error => this.handleError(error))
        );
    }
    private handleError(error: HttpErrorResponse) {
        this.hasError = true;
        return throwError(() => error);
    }
}